<template>
    <BModal v-model="isShowModal" v-bind:title="$t('devicesLogsDownloadCenter')" size="lg">
        <div class="row align-items-center">
            <BPagination class="col-4" v-model="currentPage" :total-rows="totalRows" :per-page="filesPerPage" aria-controls="my-table" />
            <div class="col-4 d-flex flex-column justify-content-center align-items-center">
                <div v-if="this.lastRefreshDateTime">
                    <div>{{ this.$t("lastRefresh") }}</div>
                    <div>{{ this.lastRefreshDateTimeString }}</div>
                </div>
            </div>
            <div class="col-4 d-flex justify-content-end">
                <button type="button" class="btn btn-sm btn-outline-primary my-3" @click="this.getAllLogFiles()"><font-awesome-icon icon="rotate" size="1x" class="m-0" /></button>
            </div>
        </div>
        
        <BTable responsive outlined striped hover show-empty :items="files" :fields="tableFields" :per-page="filesPerPage" :current-page="currentPage">
            <!-- Texts to show when the table is empty -->
            <template #empty>
                <div class="text-center my-3">{{ $t("noDataToDisplay") }}</div>
            </template>
            <template #emptyfiltered>
                <div class="text-center my-3">{{ scope.emptyFilteredText }}</div>
            </template>

            <template v-slot:cell(date)="data">
                <div class="text-nowrap">{{this.$DateTimeService.GetDateFromISO(data.value, true)}}</div>
            </template>
            <template v-slot:cell(checkpointsNames)="data">
                <ul>
                    <li :key="checkpoint" v-for="checkpoint in data.value">{{ checkpoint }}</li>
                </ul>
            </template>
            <template v-slot:cell(download)="row">
                <div class="text-nowrap">
                    <BButton variant="primary" class="btn-sm" @click="download(row.item)"><font-awesome-icon icon="download" size="1x" class="mx-1" /></BButton>
                </div>
            </template>
        </BTable>

        <template #modal-footer>
            <div class="w-100">
                <button type="button" @click="isShowModal = false" class="btn btn-outline-secondary mx-1">{{$t("close")}}</button>
            </div>
        </template>
    </BModal>
</template>

<script>
    import EventService from '../../services/event.service';
    import utilMixin from '../../mixins/utils.mixins';
    import DatetimeService from '../../services/datetime.service';

    export default {
        name : 'modalLogs',
        mixins: [utilMixin],
        components: {},
        data : function(){
            return {
                isShowModal : false,
                files: [],
                filesPerPage: 20,
                currentPage: 1,
                lastRefreshDateTime: null
            };
        },
        computed: {
            eventId : function() {
                return this.$route.params.id;
            },
            tableFields: function() {
                return [
                    { key : 'deviceId', label: "Device Id", sortable: true},
                    { key : 'date', label: "Date", sortable: true },
                    { key : 'checkpointsNames', label : this.$t("checkpoints"), sortable: false, thClass : 'text-center'},
                    { key : 'download', label: this.$t("download"), sortable: false, thClass : 'text-center', tdClass : 'text-center'}
                ];
            },
            totalRows: function() {
                return this.files.length;
            },
            lastRefreshDateTimeString(){
                return DatetimeService.GetDateTimeFromISO(this.lastRefreshDateTime.toISOString(), true)
            }
        },
        methods:{
            showModal: function() {
                this.getAllLogFiles();
                this.isShowModal = true;
            },
            getAllLogFiles(){
                EventService.getAllLogFiles(this.eventId).then(
                    resp => {
                        var response = resp.status ? resp : resp.response;
                        if(response.status == 200){
                            this.files = response.data;
                            this.lastRefreshDateTime = new Date();
                        } 
                        else {
                            
                            this.showToast(this.$t('error'), response.data, 'danger');
                        }
                    }
                ).catch(error => {
                    this.showToast(this.$t('error'), error);
                });
            },
            download: function(fileToDownload){
                EventService.getLogFileContent(this.eventId, fileToDownload.date, fileToDownload.deviceId).then(
                    resp => {
                        var response = resp.status ? resp : resp.response;
                        if(response.status == 200){
                            // Create a Blob object with the text content
                            const blob = new Blob([response.data], { type: 'text/plain' });

                            // Create a URL for the Blob
                            const url = window.URL.createObjectURL(blob);

                            // Create a link element to trigger the download
                            const a = document.createElement('a');
                            a.href = url;
                            a.download = fileToDownload.deviceId + "_" + fileToDownload.date.split("T")[0] + ".txt";

                            // Trigger a click event on the link to start the download
                            a.click();

                            // Clean up by revoking the Object URL
                            window.URL.revokeObjectURL(url);
                        } 
                        else {
                            
                            this.showToast(this.$t('error'), response.data, 'danger');
                        }
                    }
                ).catch(error => {
                    this.showToast(this.$t('error'), error);
                });
            }
        }
    }
</script>

<style scoped>
</style>
